import { useEffect } from "react";

// Auto-save form data to browser localStorage
export const useFormAutosave = (formKey, formData) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      try {
        localStorage.setItem(
          `contract_form_${formKey}`,
          JSON.stringify(formData)
        );
        console.log("✅ Form autosaved");
      } catch (e) {
        console.warn("Autosave failed:", e);
      }
    }, 1000); // Wait 1s after user stops typing

    return () => clearTimeout(timeout);
  }, [formKey, formData]);
};

// Retrieve saved form data
export const getAutosavedFormData = (formKey) => {
  try {
    const saved = localStorage.getItem(`contract_form_${formKey}`);
    return saved ? JSON.parse(saved) : null;
  } catch (e) {
    console.warn("Failed to retrieve autosave:", e);
    return null;
  }
};

// Clear autosaved data
export const clearAutosavedData = (formKey) => {
  try {
    localStorage.removeItem(`contract_form_${formKey}`);
    console.log("✅ Autosaved data cleared");
  } catch (e) {
    console.warn("Failed to clear autosave:", e);
  }
};
